import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
  },
  leftColumn: {
    width: '50%',
    height: '100%',
    backgroundColor: '#0F91AE',
    color: 'white',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  rightColumn: {
    width: '50%',
    height: '100%',
    backgroundColor: 'white',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingHorizontal: 40,
  },

  about: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.4,
    marginTop: 20,
    marginBottom: 40,
    width: '90%',
  },
  citationWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    paddingHorizontal: 20,
  },
  citation: {
    fontFamily: 'Lato',
    fontSize: 32,
    fontWeight: 700,
    textAlign: 'center',
  },
  speakerWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 30,
  },
  getReady: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 400,
  },
  title: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 900,
  },
  subtitle: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 20,
    fontWeight: 400,
    textAlign: 'center',
  },
});
